import { TWidget } from 'widgets/Widget';

/**
 * @description Base CartItem implementation
 * @param Widget Base widget for extending
 * @returns CartItem class
 */
function CartItemClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory cart
     * @class CartItem
     * @augments Widget
     * @classdesc CartItem component on Cart page. Wrapper needed for the "AddToWishlist" functionality
     * @property {string} data-widget - Widget name `CartItem`
     * @property {string} data-pid - Product ID
     * @property {string} data-text-added-to-wishlist - Added to wishlist message
     * @property {string} data-original-wishlist-button-message - Original message for `add to wishlist` button
     * @property {object} data-accessibility-alerts - Accessibility alerts messages for different user actions
     *
     * @example <caption>Example of CartItem widget markup</caption>
     * <section
     *     class="l-cart_product b-cart_product"
     *     id="cart_item_{{UUID}}"
     *     data-pid="{{id}}"
     *     data-widget="cartItem"
     *     data-tau="cart_product_item"
     *     data-text-added-to-wishlist="${Resource.msg('button.added.to.wishlist', 'wishlist', null)}"
     *     data-original-wishlist-button-message="${Resource.msg('button.add.to.wishlist', 'wishlist', null)}"
     *     data-forward-to-parent="updateQty:dismissQty:removeProduct:editProduct"
     *     data-accessibility-alerts='{
     *         "addedtowishlist": "${Resource.msg('alert.addedtowishlist', 'product', null)}",
     *         "removedfromwishlist": "${Resource.msg('alert.removedfromwishlist', 'product', null)}"
     *     }'
     * >
     * ...
     * </section>
     */
    class CartItem extends Widget {
        prefs() {
            return {
                pid: '',
                ...super.prefs()
            };
        }
    }

    return CartItem;
}

export type TCartItem = ReturnType<typeof CartItemClassCreator>;

export type TCartItemInstance = InstanceType<TCartItem>;

export default CartItemClassCreator;
